/**
 * Measure an element's bounding rect with its inline `transform` reset to
 * the identity transform. Use this when the floating element transforms
 * itself (translate to flip placement) but the placement math needs the
 * untransformed layout box. Without this, ResizeObserver callbacks would
 * feed transformed coordinates back into the next placement computation
 * and oscillate.
 */
export function measureUntransformed(el: HTMLElement): DOMRect {
  const prev = el.style.transform;
  // Setting to "none" forces the engine to recompute layout for this
  // element, so getBoundingClientRect() returns the layout box without
  // any current translate. We restore the prior transform synchronously.
  el.style.transform = "none";
  const rect = el.getBoundingClientRect();
  el.style.transform = prev;
  return rect;
}
